import {
  FETCH_BOT_NOTIFICATIONS_REQUEST,
  FETCH_BOT_NOTIFICATIONS_SUCCESS,
  FETCH_BOT_NOTIFICATIONS_FAILURE,
} from '../../constants/ActionTypes';
import { botNotifications, setAuthorizationHeader } from '../../api';
import storage from '../../storage';
import {
  getBotNotificationsData,
  getIsBotNotificationsFetching,
} from './getters';
import { errorHandler } from '../../helpers/error-handler';

export const fetchBotNotificationsSetting =
  () => async (dispatch, getState) => {
    try {
      if (getIsBotNotificationsFetching(getState())) {
        return Promise.resolve();
      }

      dispatch({
        type: FETCH_BOT_NOTIFICATIONS_REQUEST,
      });

      setAuthorizationHeader(storage.getItem('token'));

      const data = await botNotifications.getBotNotificationSettings();

      dispatch({
        type: FETCH_BOT_NOTIFICATIONS_SUCCESS,
        data,
      });

      return Promise.resolve(data);
    } catch (e) {
      const processedError = errorHandler(e);

      dispatch({
        type: FETCH_BOT_NOTIFICATIONS_FAILURE,
        data: processedError,
      });

      return Promise.reject(processedError);
    }
  };

export const updateNotificationsSetting = () => async (_dispatch, getState) => {
  try {
    const notificationEnabled = getBotNotificationsData(getState())?.enabled
      ? true
      : false;

    const toggleNotificationEnabled = !notificationEnabled;

    setAuthorizationHeader(storage.getItem('token'));

    await botNotifications.updateNotificationConfig(toggleNotificationEnabled);

    return Promise.resolve();
  } catch (e) {
    const processedError = errorHandler(e);

    return Promise.reject(processedError);
  }
};

export const updateMedium = (medium) => async (_dispatch, getState) => {
  try {
    if (!medium) {
      return Promise.resolve();
    }

    setAuthorizationHeader(storage.getItem('token'));

    const notificationEnabled = getBotNotificationsData(getState())?.enabled
      ? true
      : false;

    const data = await botNotifications.updateNotificationConfig(
      notificationEnabled,
      medium
    );

    return Promise.resolve(data);
  } catch (e) {
    const processedError = errorHandler(e);

    return Promise.reject(processedError);
  }
};

export const telegramDelink = () => async () => {
  try {
    setAuthorizationHeader(storage.getItem('token'));

    const data = await botNotifications.telegramDelink();

    return Promise.resolve(data);
  } catch (e) {
    const processedError = errorHandler(e);

    return Promise.reject(processedError);
  }
};

export const telegramSaveToken = (token) => async () => {
  try {
    setAuthorizationHeader(storage.getItem('token'));

    const data = await botNotifications.telegramSaveToken(token);

    return Promise.resolve(data);
  } catch (e) {
    const processedError = errorHandler(e);

    return Promise.reject(processedError);
  }
};
